import React, {useContext, useEffect} from "react";
import './sass/PatientPage.sass'
import {useHttp} from "../../../hooks/http.hook";
import {AuthContext} from "../../../context/AuthContext";
import {observer} from "mobx-react";
import PatientPageTemplate from "./PatientPageTemplate";
import PatientPageStore from "./Store/PatientPageStore";
import {useAPI} from "../../../hooks/useAPI";

const PatientPage = observer(() => {
    const {userId, token } = useContext(AuthContext)
    const {request} = useHttp()
    const baseURL = process.env.REACT_APP_BASE_URL
    const {APIRequest} = useAPI()

    const getData = async () => {
        const url = `${baseURL}/api/v2/patients/${userId}`
        try {
            const {data, status} = await request(url, 'GET', null, {Authorization: `Bearer ${token?.token}`})
            return {data, status}
        } catch (e) {
            // console.log(e)
        }
    }
    const getImage  = async ()=>{
        return await APIRequest({api:`/api/v1/patients/${userId}/results`, method: 'GET'})
            .then(res => {
            return res?.message
        })
    }
    //Отправка запроса на получение данных о пользователе
    useEffect(() => {
        getData()
            .then((r) => {
                if (r?.status === 200) {
                    PatientPageStore.setPatientInfo(r.data?.data?.attributes)
                    PatientPageStore.setPatientResults(r.data.data?.results)
                }
            })
    }, [])

    //Template
    return (
            <PatientPageTemplate getImage={getImage}/>


    );
})

export default PatientPage
